import React from "react";
import Header from "./Header";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <>
      <Header />
      <body className="">
        <div className="wrapper">
          <div className="error-404">
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <center>
              <h2 className="font-bold">
                404 <br />
                Page not found.
              </h2>
              <div className="error-desc">
                <Link
                  onclick="window.history.go(-1); return false;"
                  className="btn btn-primary"
                >
                  <span className="glyphicon glyphicon-home"></span> Go back to
                 Home Page
                </Link>
              </div>
            </center>
          </div>
        </div>
      </body>
    </>
  );
}

export default NotFound;
